<script setup lang="ts">

import {PropType} from "vue";

let props = defineProps({
    title: String,
    image: String,
    url: Object as PropType<{name: string, url: string}>,
    reversed: Boolean,
    coverImage: {
        type: Boolean,
        default: true
    }
});

</script>
<template>
    <article class="component-large-image-text">
        <div class="grid grid-cols-6 container p-0">
            <div
                class="text-container col-span-6 lg:col-span-3"
                :class="{'lg:order-last order-first': props.reversed}">
                <h2>{{ props.title }}</h2>
                <slot></slot>
                <a v-if="props.url" :href="props.url.url" target="_blank">{{ props.url.name }}</a>
            </div>
            <div class="col-span-6 lg:col-span-3">
                <div
                    class="image-container"
                    :class="{'cover': props.coverImage}">
                    <img :src="props.image" :alt="props.title">
                </div>
            </div>
        </div>
    </article>
</template>
<style scoped lang="scss">
@use "@scss/components/large-image-text";
</style>
